import React from "react";

import { CapStatsSummary as CapStatsSummaryComponent } from "heat-next";

import { useSessionDetailsContext } from "@/context/session-details/session-details";

import { ComponentWrapper } from "@/pages/shared/shared.styles";

import ContentLoader from "@/components/content-loader/content-loader";
import EmptyState from "@/components/empty-state/empty-state";
import { EmptyStateType } from "@/components/empty-state/empty-state.types";

interface CapStatsSummaryProps {
    isInsideModal?: boolean;
    subDimensionsData?: any[];
    id?: string;
}

const findCapEntry = (entries: any[] | undefined) =>
    entries?.find((entry) => entry?.code?.toLowerCase() === "cap");

const isCapEntryEmpty = (entry: any | undefined) => {
    if (!entry) {
        return true;
    }

    const left = entry?.datasets?.left;
    const right = entry?.datasets?.right;

    return !left?.length && !right?.length;
};

const CapStatsSummary: React.FC<CapStatsSummaryProps> = ({
    isInsideModal = false,
    subDimensionsData,
    id = "cap",
}) => {
    const { statsSummaryData, isFetchingStatsSummary, isErrorStatsSummary } =
        useSessionDetailsContext();

    const sourceData = isInsideModal ? subDimensionsData : statsSummaryData;
    const capData = findCapEntry(sourceData);

    const isEmptyState = () => {
        if (isInsideModal) {
            return isCapEntryEmpty(capData);
        }

        return !isErrorStatsSummary && isCapEntryEmpty(capData);
    };

    if (isFetchingStatsSummary && !isInsideModal) {
        return <ContentLoader height="15rem" />;
    }

    if (isEmptyState()) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="session-details:cap-stats-summary:empty-state:title"
                    emptyStateType={EmptyStateType.Charts}
                    minHeight="15rem"
                />
            </ComponentWrapper>
        );
    }

    if (!isInsideModal && isErrorStatsSummary && !isFetchingStatsSummary) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="error-state:title"
                    description="error-state:description"
                    emptyStateType={EmptyStateType.Error}
                    minHeight="15rem"
                />
            </ComponentWrapper>
        );
    }

    return <CapStatsSummaryComponent data={capData} id={id} />;
};

export default CapStatsSummary;
